import { Row, Col, Card, Button, Skeleton, Avatar, Image } from "antd";
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import { Badge } from "antd";
import moment from "moment";

import lang from "../../helper/lang";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { capitalize } from "../../helper/functions";

function AdminView() {
  const params = useParams();
  const { request } = useRequest();
  const [list, setList] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchData = (id) => {
    setLoading(true);
    console.log(`${apiPath.viewAdmin}/${id}`);
    request({
      url: `${apiPath.viewAdmin}/${id}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    fetchData(params.id);
  }, []);

  return (
    <>
      <Row gutter={16}>
        <Col span={24}>
          <div className="float-left mb-1">
            <Button
              className="ant-btn ant-btn-primary"
              onClick={() => navigate(-1)}
            >
              <ArrowLeftOutlined />
            </Button>
          </div>
        </Col>
        <Col span={24} xs={24}>
          <Card title="Sub-Admin Information">
            {loading ? (
              [1, 2, 3].map((item) => <Skeleton active key={item} />)
            ) : (
              <div className="view-main-list">
                <Row gutter={[36, 24]}>
                  <Col span={24}>
                    <div className="view-inner-cls new-view-inner-class-m">
                      <h5>{lang("Name")}:</h5>
                      <h6>
                        <span className="cap">
                          {list.name ? list.name : "-"}
                        </span>
                      </h6>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className="view-inner-cls new-view-inner-class-m">
                      <h5>{lang("Email") + " " + lang("Address")}:</h5>
                      <h6>{list.email ? list.email : "-"}</h6>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className="view-inner-cls new-view-inner-class-m">
                      <h5>{lang("Mobile") + " " + lang("Number")}:</h5>
                      <h6>
                        {list.country_code ? "+" + list.country_code + "-" : ""}
                        {list.phone ? list.phone : "-"}
                      </h6>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className="view-inner-cls new-view-inner-class-m">
                      <h5>Role:</h5>
                      <h6>{list.role ? list.role : "-"}</h6>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className="view-inner-cls new-view-inner-class-m">
                      <h5>Status:</h5>
                      <h6>
                        {list.status === "Active" ? (
                          <Badge status="success" text="Active" />
                        ) : (
                          <Badge status="error" text="InActive" />
                        )}
                      </h6>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className="view-inner-cls new-view-inner-class-m new-view-inner-class-m-no-flex">
                      <h5>Permissions:</h5>

                      {list?.permissions ? (
                        Object.entries(list.permissions)
                          // ❌ filter out non-module keys
                          .filter(
                            ([key]) =>
                              ![
                                "_id",
                                "createdAt",
                                "updatedAt",
                                "__v",
                                "createdBy",
                                "updatedBy",
                              ].includes(key),
                          )
                          .map(([module, moduleData]) => (
                            <div
                              key={module}
                              style={{
                                border: "1px solid #f0f0f0",
                                borderRadius: 8,
                                padding: 12,
                                marginBottom: 12,
                              }}
                            >
                              {/* MODULE NAME */}
                              <div style={{ marginBottom: 8 }}>
                                <strong style={{ textTransform: "capitalize" }}>
                                  {module}
                                </strong>{" "}
                                {moduleData?.enabled ? (
                                  <Badge status="success" text="Enabled" />
                                ) : (
                                  <Badge status="default" text="Disabled" />
                                )}
                              </div>

                              {/* PERMISSION ACTIONS */}
                              <Row gutter={[16, 8]}>
                                {Object.entries(
                                  moduleData?.permissions || {},
                                ).map(([action, allowed]) => (
                                  <Col span={6} key={action}>
                                    <Badge
                                      status={allowed ? "success" : "error"}
                                      text={
                                        action.charAt(0).toUpperCase() +
                                        action.slice(1)
                                      }
                                    />
                                  </Col>
                                ))}
                              </Row>
                            </div>
                          ))
                      ) : (
                        <span>-</span>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default AdminView;
